__turbopack_context__.v({
  "TabTrigger": "tab-selector-module__my3IUq__TabTrigger",
});
